import { createContext } from "react";
import {
  type AdvertiserAudiencesAbContextValue,
  type AdvertiserAudiencesContextValue,
  type AdvertiserAudiencesV3ContextValue,
  type PublisherAudiencesAbContextValue,
  type PublisherAudiencesContextValue,
} from "features/mediaDataRoom/contexts";
import { type MediaDataRoomVersion } from "features/mediaDataRoom/models";

export type AudiencesContextValue =
  | PublisherAudiencesContextValue
  | AdvertiserAudiencesContextValue;

export type AudiencesAbContextValue =
  | PublisherAudiencesAbContextValue
  | AdvertiserAudiencesAbContextValue;
export type AudiencesV3ContextValue = AdvertiserAudiencesV3ContextValue;

export interface AudiencesContextHook {
  (version?: never): AudiencesContextValue;
  (version: MediaDataRoomVersion.v3): AudiencesV3ContextValue;
  (version: MediaDataRoomVersion.ab): AudiencesAbContextValue;
}

export type AudiencesContextValueKeys = keyof AudiencesContextValue;

export const AudiencesContext = createContext<AudiencesContextValue | null>(
  null
);
AudiencesContext.displayName = "AudiencesContext";
